import { httpStatus } from '../utils/http-utils';

interface Task {
  url: string;
  body: object;
  token?: string;
}

interface GetTask {
  url: string;
  token?: string;
}

interface DeleteTask {
  url: string;
  token?: string;
}

export const getTask = ({ url, token }: GetTask) => {
  const headers: HeadersInit = token
    ? {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    : { 'Content-Type': 'application/json' };

  const options: RequestInit = {
    method: 'GET',
    headers,
    credentials: 'include',
  };
  return fetch(url, options)
    .then(httpStatus)
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const postTask = ({ url, body, token }: Task) => {
  const headers = {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  };

  const options: RequestInit = {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({ ...body }),
  };
  return fetch(url, options)
    .then(httpStatus)
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const patchTask = ({ url, body, token }: Task) => {
  const headers: HeadersInit = token
    ? {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    : { 'Content-Type': 'application/json' };

  const options: RequestInit = {
    method: 'PATCH',
    headers,
    credentials: 'include',
    body: JSON.stringify({ ...body }),
  };
  return fetch(url, options)
    .then(httpStatus)
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const uploadTask = ({ url, body: bodyRaw, token }: Task) => {
  const headers = {
    ...(token && { Authorization: `Bearer ${token}` }),
  };

  const body = new FormData();

  Object.entries(bodyRaw)
    .filter(([_, file]) => file?.name)
    .forEach(([key, file]) => {
      body.append(key, file);
    });

  const options = {
    method: 'PATCH',
    headers,
    body,
  };

  return fetch(url, options)
    .then(httpStatus)
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const deleteTask = ({ url, token }: DeleteTask) => {
  const headers: HeadersInit = token
    ? {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    : { 'Content-Type': 'application/json' };

  const options: RequestInit = {
    method: 'DELETE',
    headers,
    credentials: 'include',
    body: JSON.stringify({}),
  };
  return fetch(url, options)
    .then(httpStatus)
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const getCSVTask = ({ url, token }: GetTask) => {
  const headers: HeadersInit = token
    ? {
        'Content-Type': 'text/csv',
        Authorization: `Bearer ${token}`,
      }
    : { 'Content-Type': 'text/csv' };

  const options: RequestInit = {
    method: 'GET',
    headers,
    credentials: 'include',
  };
  return fetch(url, options)
    .then(response => httpStatus(response, true))
    .then(response => ({ response }))
    .catch(error => ({ error }));
};
